<template>
  <v-container
    fluid
    grid-list-sm>
    <v-toolbar
      color="primary">
      <v-toolbar-title
        class="headline white--text">
        {{ $t(translation + ".header") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        class="mr-4 info"
        dark
        @click="addEditItemDialog=true">
        {{ $t(translation + '.add') }}
      </v-btn>
      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            :loading="tableDataLoading"
            :disabled="tableDataLoading"
            v-bind="attrs"
            v-on="on"
            class="warning"
            @click="refreshData(true, true)"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('tooltips.refresh') }}</span>
      </v-tooltip>

    </v-toolbar>
    <v-spacer></v-spacer>
    <v-data-table
      dark
      :mobile-breakpoint="breakpoint"
      :page="page"
      :pageCount="numberOfPages"
      :headers="headers"
      :items="tableData"
      :options.sync="options"
      :items-per-page="itemsPerPage"
      :server-items-length="totalRows"
      :footer-props="{
        itemsPerPageOptions: itemsPerPageOptions,
        'items-per-page-text': '',
        'page-text': fromItem + '-' + toItem + ' ' + $t('general.of') + ' ' + totalRows
      }"
      :dense="true"
      :loading-text="$t('loading_data')"
      class="elevation-1 secondary white--text"
      :loading="tableDataLoading"
    >
      <template v-slot:item.is_active="{ item }">
        <v-chip small
                :class="{'error inactive-row white--text':(!item.is_active) , 'secondary white--text':(item.is_active)}">
          {{ item.is_active ? $t('active') : $t('not_active') }}
        </v-chip>
      </template>
      <!-------------------------------------  DETAILS EDIT DELETE  ----------------------------------------------->
      <template v-slot:item.actions="{ item }">
        <v-layout align-center justify-center>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click.stop="openAddEditDialog(item)">
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('tooltips.edit') }}</span>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                dark
                :loading="deleteLoadingId === item.id"
                @click="onDelete(apiDelete,item)">
                <v-icon v-if="item.is_active">mdi-trash-can-outline</v-icon>
                <v-icon v-else>mdi-autorenew</v-icon>
              </v-btn>
            </template>
            <span>{{ item.is_active ? $t('tooltips.deactivate') : $t('tooltips.activate') }}</span>
          </v-tooltip>

        </v-layout>
      </template>
      <!----------------------------------- ## FILTERS ## ------------------------------------>
      <template v-slot:body.prepend>
        <tr style="height: 60px !important;">
          <th
            v-for="header in headers"
            :key="header.name"
            class="py-0 px-2 my-0 secondary white--text">
            <v-select
              v-if="header.name === 'active'"
              class="justify-center pt-2 mt-0"
              dark
              dense
              hide-details
              v-model="filters[header.value]"
              @change="refreshData(true)"
              :items="activeObjects"
              item-value="value"
              item-text="text"
              style="font-size: inherit; text-align: right !important;">
            </v-select>
            <v-text-field
              v-else-if="header.name !== 'actions'"
              v-model="filters[header.value]"
              @keyup.enter.native="refreshData(true)"
              :placeholder="'Filter ' + header.text"
              filled
              dense
              height="10px"
              hide-details
              style="font-size: inherit;"
              class="secondary ma-0 pa-0"
              v-eager
              enterkeyhint="done"
            ></v-text-field>
            <v-layout
              v-else class="justify-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="tableDataLoading"
                    color="info"
                    @click="refreshData(true)">
                    <v-icon>mdi-search-web</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.search') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    class="ml-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="tableDataLoading"
                    color="error"
                    @click="refreshData(true, true)">
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('tooltips.cancel_search') }}</span>
              </v-tooltip>
            </v-layout>
          </th>
        </tr>
      </template>
      <!-------------------------------- ## NO DATA ## ----------------------------------->
      <template v-slot:no-data>
        <div class="text-xs-center">
          <v-alert color="error" icon="mdi-alert-circle-outline">
            {{ errorMessage }}
          </v-alert>
        </div>
      </template>
    </v-data-table>
    <!---------------------------------- Add/Edit item Dialog  ----------------------------------------->
    <add-edit-item
      :addItemDialog="addEditItemDialog"
      :dataForModal="dataForModal"
      @close="closeAddEditDialog"
      @addEmit="addEmit"
      @editEmit="editEmit"
    />
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  findById,
  addEmit,
  editEmit,
  onDelete,
  readTableDataPost,
  readTableDataPostPagination,
  refresh,
  search
} from "../../../statics/DataTableFunctions";
import AddEditCbHelpReceiver from "../../../components/cb/helpReceivers/AddEditCbHelpReceiver";


export default {
  name: "CbHelpReceivers",
  components: {
    'add-edit-item': AddEditCbHelpReceiver,
  },
  data() {
    return {
      breakpoint: 0,
      page: 1,
      numberOfPages: 10,
      totalRows: 0,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        10,
        20,
        30,
        50,
        100,
        200,
        500
      ],
      options: {
        sortBy: [
          'name'
        ],
        sortDesc: [
          false
        ]
      },
      translation: 'cb.help_receivers',
      apiRead: '/api/cb_help_receivers/index',
      showColumns: [
        "id",
        "name",
        "pin",
        "is_active",
        "cb_help_user_type_id",
        "cb_activity_id"
      ],
      showColumnsCbHelpUserTypeRelation: [
        "id",
        "name"
      ],
      showColumnsCbActivityRelation: [
        "id",
        "name"
      ],
      apiDelete: '/api/cb_help_receivers/destroy',
      dataForModal: null,
      addEditItemDialog: false,
      editItemDialog: false,
      tableDataLoading: false,
      tableData: [],
      filteredTableData: [],
      filters: {
        is_active: '',
      },
      deleteLoadingId: -1,
      errorMessage: this.$t('no_data'),
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },

    }
  },
  methods: {
    search,
    findById,
    refresh,
    onDelete,
    readTableDataPost,
    readTableDataPostPagination,
    addEmit,
    editEmit,
    openAddEditDialog(item) {
      this.addEditItemDialog = true;
      this.dataForModal = item;
    },
    closeAddEditDialog() {
      this.addEditItemDialog = false;
      this.dataForModal = null;
    },
    refreshData(resetPagination = false, resetFilters = false) {
      if (resetPagination) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        this.isRefreshingData = true;
      }
      if (resetFilters) {
        Object.keys(this.filters).forEach(f => {
          this.filters[f] = ''
        });
      }
      this.readTableDataPostPagination(this.apiRead, false, this.showColumns, {
        filters: this.filters,
        options: this.options,
        show_columns_cb_help_user_type_relation: this.showColumnsCbHelpUserTypeRelation,
        show_columns_cb_activity_relation: this.showColumnsCbActivityRelation
      });
    }
  },
  computed: {
    fromItem() {
      return this.options.page === 1 ? 1 : (this.options.page - 1) * this.options.itemsPerPage + 1
    },
    toItem() {
      if (this.options.itemsPerPage > this.totalRows) {
        return this.totalRows;
      }
      if (this.options.page === 1) {
        return this.options.itemsPerPage
      }

      const toItems = this.options.page * this.options.itemsPerPage;

      if (toItems > this.totalRows) {
        return this.totalRows;
      }

      return toItems;
    },
    headers() {
      return [
        {
          text: this.$t(this.translation + '.name'),
          name: 'name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: this.$t(this.translation + '.pin'),
          name: 'pin',
          align: 'left',
          sortable: true,
          value: 'pin'
        },
        {
          text: this.$t(this.translation + '.type'),
          name: 'type',
          align: 'left',
          sortable: true,
          value: 'cb_help_user_type.name'
        },
        {
          text: this.$t(this.translation + '.activity'),
          name: 'activity',
          align: 'left',
          sortable: true,
          value: 'cb_activity.name'
        },
        {
          text: this.$t(this.translation + '.active'),
          name: 'active',
          align: 'left',
          sortable: true,
          value: 'is_active'
        },
        {
          text: this.$t('actions'),
          name: 'actions',
          align: 'center',
          sortable: false,
          value: 'actions'
        },
      ]
    },
    activeObjects() {
      return [
        {value: "", text: this.$t('all')},
        {value: 'true', text: this.$t('active')},
        {value: 'false', text: this.$t('not_active')},
      ]
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.isRefreshingData) {
          this.refreshData()
        }
      },
      deep: true
    },
  },
}
</script>

<style>

</style>

